// Generate an error message from the server response
export function errorDescriptionFromResponse(response) {
  let details = response.data ? response.data : response;
  if (details.error_hint || details.error_description || details.invalid_fields) {
    return `${details.error_hint || details.error_description} ${invalidFieldsToSentence(
      details.invalid_fields
    )}`;
  }
  return details;
}

function invalidFieldsToSentence(fields) {
  if (!fields) {
    return '';
  }
  var sentence = '';
  Object.keys(fields).forEach(function (k) {
    sentence += `${cleanSlugKey(k)} ${fields[k]}. `;
  });
  return sentence;
}

function cleanSlugKey(key) {
  key = key.replace(/_/g, ' ');
  return key[0].toUpperCase() + key.substr(1).toLowerCase();
}



// WEBPACK FOOTER //
// ./app/utils/error.js